export default __webpack_public_path__ + "img/14182dd2d51abe08e960d40a93937810.svg";